/*
 * Takaaf Scroll Reveal — injected via assets/takaaf-scroll-reveal.js
 * Watches for [data-takaaf-reveal] and [data-takaaf-reveal-group]
 * and adds .is-visible when they enter the viewport.
 */
(function () {
  'use strict';

  var THRESHOLD = 0.12;
  var SELECTOR = '[data-takaaf-reveal], [data-takaaf-reveal-group]';

  function init() {
    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: show everything immediately
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: THRESHOLD,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) { observer.observe(el); });
  }

  // Auto-tag key page elements so they animate in
  function tagElements() {
    // Section headings
    document.querySelectorAll(
      '.featured-collection .title, .collection-list .title, .why-takaaf__label, .why-takaaf__heading'
    ).forEach(function (el) {
      if (!el.hasAttribute('data-takaaf-reveal')) {
        el.setAttribute('data-takaaf-reveal', '');
      }
    });

    // Why Takaaf grid
    document.querySelectorAll('.why-takaaf__grid').forEach(function (el) {
      if (!el.hasAttribute('data-takaaf-reveal-group')) {
        el.setAttribute('data-takaaf-reveal-group', '');
      }
    });

    // Product card grids — each grid fades up as a staggered group
    document.querySelectorAll(
      '.featured-collection .product-grid, .collection-list__grid'
    ).forEach(function (grid) {
      if (!grid.hasAttribute('data-takaaf-reveal-group')) {
        grid.setAttribute('data-takaaf-reveal-group', '');
      }
    });

    // Individual product cards on collection pages
    document.querySelectorAll(
      '.collection .product-grid .grid__item, .collection .product-grid .card-wrapper'
    ).forEach(function (card, i) {
      if (!card.hasAttribute('data-takaaf-reveal')) {
        card.setAttribute('data-takaaf-reveal', '');
        // Stagger delay via inline style
        card.style.transitionDelay = (i % 4) * 0.08 + 's';
      }
    });

    // Trust strip, bank banner, FAQ, reviews on product page
    document.querySelectorAll(
      '.trust-strip-wrapper, .bank-discount-wrapper, .product-faq-section, .product-reviews-section, .cross-sell-section, .why-takaaf-wrapper'
    ).forEach(function (el) {
      if (!el.hasAttribute('data-takaaf-reveal')) {
        el.setAttribute('data-takaaf-reveal', '');
      }
    });

    // Benefit bullets
    document.querySelectorAll('.benefit-list').forEach(function (el) {
      if (!el.hasAttribute('data-takaaf-reveal-group')) {
        el.setAttribute('data-takaaf-reveal-group', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      tagElements();
      init();
    });
  } else {
    tagElements();
    init();
  }
})();
